import { render, staticRenderFns } from "./DividendDeclarationSuccess.vue?vue&type=template&id=9d8b5bea&scoped=true"
import script from "./DividendDeclarationSuccess.vue?vue&type=script&lang=js"
export * from "./DividendDeclarationSuccess.vue?vue&type=script&lang=js"
import style0 from "./DividendDeclarationSuccess.vue?vue&type=style&index=0&id=9d8b5bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8b5bea",
  null
  
)

export default component.exports